import { getGlobal } from 'reactn';
import InvokeFields from "./InvokeFields";

export default class SocialUtil {

    public static ACCESS_TOKEN_URI = "https://www.linkedin.com/oauth/v2/accessToken";
    public static REDIRECT_URI = "http://localhost:3028/linkedin";
    public static CLIENT_ID = "772vxd8ptehzmg";
    public static CLIENT_SECRET = "girroR9YCp01oHXv";
    public static authorizationURL = 'https://www.linkedin.com/oauth/v2/authorization';

    public static getAuthorizationUrl() {
        //const state = Buffer.from(Math.round(Math.random() * Date.now()).toString()).toString('hex');
        const scope = encodeURIComponent('r_liteprofile r_emailaddress r_organization_social w_member_social rw_organization_admin w_organization_social r_organization_social rw_organization_admin');
        const url = this.authorizationURL + "?response_type=code&client_id=" + this.CLIENT_ID + "&redirect_uri=" + encodeURIComponent(this.REDIRECT_URI) + "&scope=" + scope;
        return url;
    }

    public static async getLinkedInAccessToken(authToken:string):Promise<string> {
        let accessTokenInput: LinkedInAccessTokenInput = {
            field: InvokeFields.getLinkedInAccessToken,
            code: authToken
        };

        return new Promise(async function (resolve) {
            let accessTokens = await getGlobal().dataManager.perform("getLinkedInAccessToken", accessTokenInput);
            console.log("Got LinkedIn access tokens")
            console.log(accessTokens);
            resolve(accessTokens[0].code);
        });
        /*return new Promise(async function (resolve) {
            resolve(null);
        });*/
    }

    public static async getLinkedInProfile():Promise<any> {


        return new Promise(async function (resolve) {
            resolve(null);
        });
    }
}